import React from "react";
import DocumentViewer from "../../components/documents/document-viewer";

const MiniPackTemplateViewerPage: React.FC = () => {
  return (
    <DocumentViewer
      downloadEndpointBuilder={(id) => `/api/mini-pack-templates/${id}/download`}
      backPath="/access-management/tenant-management"
      title="Mini-Pack Template Preview"
    />
  );
};

export default MiniPackTemplateViewerPage;